<template>
  <v-select 
    v-model="selected" 
    :items="options" 
    item-text="value" 
    item-value="id" 
    :label="label" 
    outlined 
    dense
    class="no-details" 
    :return-object="returnObject"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple"
    :disabled="isDisabled"
    clearable 
    @change="onSelect" 
  />
</template>

<script>
export default {
  name: 'KantorCabang',
  props: {
    value: {
      type: [Object, Array],
      default: null
    },
    label: {
      type: String,
      default: 'Pilih Cabang'
    },
    apiUrl: {
      type: String,
      default: 'api/kantor/list-all'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      options: [],
      selected: this.multiple ? (this.value || []) : this.value
    }
  },
  computed: {
    isDisabled() {
      if (this.disabled !== null) {
        return this.disabled
      }
      const user = this.$gate?.user
      const userRoleId = user?.roles_id
      const branchIds = user?.branch_ids

      if (userRoleId >= 4) {
        // Jika user kantor cabang punya child branches > 1, jangan disabled
        if (Array.isArray(branchIds) && branchIds.length > 1) {
          return false
        }
        if (this.options && this.options.length > 1) {
          return false
        }
        return true
      }
      return false
    }
  },
  watch: {
    value(val) {
      this.selected = val
    },
    options(newOptions) {
      if (this.multiple) {
        // Multi-select: sync array items
        if (Array.isArray(this.selected) && this.selected.length > 0) {
          this.selected = this.selected.map(item => {
            const found = newOptions.find(opt => opt.id === item.id)
            return found || item
          })
        }
      } else {
        // Single-select: sync single item
        if (this.selected && this.selected.id) {
          const found = newOptions.find(opt => opt.id === this.selected.id)
          if (found) this.selected = found
        }
      }
    }
  },
  methods: {
    async fetchOptions() {
      try {
        const res = await (this.$axios || axios).get(this.apiUrl)
        this.options = res?.data?.data || []

        const user = this.$gate?.user
        const userCabangId = user?.kantor_id
        const userRoleId = user?.roles_id

        // Auto-select hanya jika role >= 4 dan mode single-select
        if (!this.value && !this.multiple && userRoleId >= 4 && userCabangId) {
          const found = this.options.find(opt => opt.id === userCabangId)
          if (found) {
            this.selected = found
            this.$emit('input', found)
          }
        } else if (this.selected) {
          if (this.multiple && Array.isArray(this.selected)) {
            // Sync multi-select items
            this.selected = this.selected.map(item => {
              const found = this.options.find(opt => opt.id === item.id)
              return found || item
            })
            this.$emit('input', this.selected)
          } else if (!this.multiple && this.selected.id) {
            // Sync single-select item
            const found = this.options.find(opt => opt.id === this.selected.id)
            if (found) {
              this.selected = found
              this.$emit('input', found)
            }
          }
        }

      } catch (e) {
        console.error('Gagal mengambil daftar kantor bank:', e)
      }
    },
    onSelect(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    this.fetchOptions()
  }
}
</script>